import * as React from "react";
import * as Immutable from "immutable";
import { OKTA_TYPE_KEY } from "authentication/components/oidc/constants";
import { DocumentTitle, Spinner } from "components/common";
import WizardPageHeader from "components/authentication/directoryServices/ldap/WizardPageHeader";
import SectionComponent from "components/common/Section/SectionComponent";
import Routes from "routing/Routes";
import useInitialGroupSyncValues from "authentication/logic/oidc/useInitialGroupSyncValues";
import OidcBackendMetaProvider from "authentication/components/oidc/config/components/OidcBackendMetaProvider";
import LicenseCheck from "license/LicenseCheck";
import useHistory from "routing/useHistory";
import getDisplayName from "authentication/helpers/getDisplayName";
import { handleUpdate } from "./helpers/handleSubmit";
import payloadFromFormValues from "./helpers/payloadFromFormValues";
import BackendWizard from "./BackendWizard";
const BackendEdit = ({ authenticationBackend }) => {
  const history = useHistory();
  const { formValues: groupFormValues, finishedLoading } = useInitialGroupSyncValues(
    authenticationBackend.id,
    authenticationBackend.config.type,
    { teamSelection: Immutable.Set() }
  );
  if ((authenticationBackend == null ? void 0 : authenticationBackend.id) && !finishedLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const {
    config: { type: backendType }
  } = authenticationBackend;
  const isOkta = backendType === OKTA_TYPE_KEY;
  const displayName = getDisplayName(backendType);
  const title = `Edit ${displayName} Authentication Service`;
  const onSubmitForm = (values, backendGroupSyncIsActive, shouldUpdateGroupSync) => handleUpdate(
    payloadFromFormValues(values),
    authenticationBackend.id,
    values,
    backendGroupSyncIsActive,
    shouldUpdateGroupSync
  ).then(() => {
    history.push(Routes.SYSTEM.AUTHENTICATION.BACKENDS.OVERVIEW);
  }).catch((error) => {
    throw error;
  });
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title }, /* @__PURE__ */ React.createElement(WizardPageHeader, { authenticationBackend }), /* @__PURE__ */ React.createElement(SectionComponent, { title }, /* @__PURE__ */ React.createElement(LicenseCheck, null, ({ licenseIsValid }) => /* @__PURE__ */ React.createElement(
    OidcBackendMetaProvider,
    {
      defaultValue: {
        backendId: authenticationBackend == null ? void 0 : authenticationBackend.id,
        backendGroupSyncIsActive: !!(groupFormValues == null ? void 0 : groupFormValues.synchronizeGroups),
        licenseIsValid
      }
    },
    /* @__PURE__ */ React.createElement(
      BackendWizard,
      {
        authenticationBackend,
        onSubmitForm,
        groupSyncValues: groupFormValues,
        backendType,
        isOkta
      }
    )
  ))));
};
export default BackendEdit;
